'use memo'

import { AgxGlyph, AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2'
import './ContractInformationLockedState.scss'

const LOCKED_TEXT = 'Unlocks when the contract is Accepted or Unconditional.'

export function ContractInformationLockedState() {
  return (
    <section
      className="contractInformationLockedState"
      aria-label="Contract information locked"
    >
      <AgxSpacer
        className="contractInformationLockedState-content"
        contentAlignment="center"
        gap="md"
      >
        <AgxGlyph type="locked" width={110} height={110} />
        <AgxTypography
          id="contractInformationLockedStateText"
          type="heading"
          size="x-large"
          color="var(--text-primary)"
          style={{ textAlign: 'center' }}
        >
          {LOCKED_TEXT}
        </AgxTypography>
      </AgxSpacer>
    </section>
  )
}
